import currency from "./currency";

/**
 * Decorates number-formatter with wrapping negative values with parences
 *
 * @type {(formatter: (value: number) => string) => (value: number) => string} */
export const negativeParences = formatter => value =>
	value < 0 ? `(${formatter(-value)})` : formatter(value);

export const currencyNp = negativeParences(currency);
